function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
var _require = require('../web3-amount'),
  decimalIsPositive = _require.decimalIsPositive;
function escapeHtml() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function formatAmount(value) {
  var raw = String(value !== null && value !== void 0 ? value : '').trim();
  if (/^\d+(\.\d+)?$/.test(raw)) {
    var _raw$split = raw.split('.'),
      _raw$split2 = _slicedToArray(_raw$split, 2),
      whole = _raw$split2[0],
      _raw$split2$ = _raw$split2[1],
      fraction = _raw$split2$ === void 0 ? '' : _raw$split2$;
    var head = whole.replace(/^0+(?=\d)/, '') || '0';
    var tail = fraction.replace(/0+$/, '');
    var normalized = tail ? "".concat(head, ".").concat(tail) : head;
    var _normalized$split = normalized.split('.'),
      _normalized$split2 = _slicedToArray(_normalized$split, 2),
      shownWhole = _normalized$split2[0],
      _normalized$split2$ = _normalized$split2[1],
      shownFraction = _normalized$split2$ === void 0 ? '' : _normalized$split2$;
    var grouped = shownWhole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return shownFraction ? "".concat(grouped, ".").concat(shownFraction) : grouped;
  }
  var amount = Number(value);
  if (!Number.isFinite(amount)) {
    return '0';
  }
  return amount.toLocaleString('en-US', {
    maximumFractionDigits: 8
  });
}
module.exports = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$rows = _ref.rows,
    rows = _ref$rows === void 0 ? [] : _ref$rows;
  var body = rows.length ? rows.map(function (row) {
    var ticker = escapeHtml(row.ticker);
    var eligible = row.eligible || 0;
    var pending = row.pending || 0;
    var withdraw = decimalIsPositive(eligible) ? "<button type=\"button\" class=\"withdraw-link\" data-action=\"withdraw\" data-ticker=\"".concat(ticker, "\">You can withdraw this</button>") : '';
    return "\n            <tr>\n              <th scope=\"row\">".concat(ticker, "</th>\n              <td>\n                <div class=\"eligible\">\n                  <span class=\"amount\">").concat(escapeHtml(formatAmount(eligible)), "</span>\n                  <span class=\"label\">eligible</span>\n                  ").concat(withdraw, "\n                </div>\n                <div class=\"pending\">\n                  <span class=\"amount\">").concat(escapeHtml(formatAmount(pending)), "</span>\n                  <span class=\"label\">pending</span>\n                </div>\n              </td>\n            </tr>");
  }).join('') : "<tr><td class=\"empty\" colspan=\"2\">No web3 currencies are available from this server.</td></tr>";
  return "\n    <section class=\"store-withdrawals\">\n      <h2 class=\"title\">Your web3 crypto balance:</h2>\n      <table class=\"balances\">\n        <tbody>".concat(body, "</tbody>\n      </table>\n    </section>\n  ");
};